import { useQuery } from "@tanstack/react-query";
import useGetOrg from "src/hooks/useGetOrganization";
import { useGetAppRedirectsRequest } from "src/services/organizations/queries/redirects";

export const useGetRedirects = () => {
	const { id } = useGetOrg();
	const { data: appId } = useQuery<string>({ queryKey: ["apps", "selected"], initialData: "" });

	const { data, isLoading } = useGetAppRedirectsRequest({ orgId: id, appId });

	return {
		data: data ?? [],
		isLoading
	};
};
